// import objHandler from "@/plugins/ObjectHandler.js";
import { EventBus } from "../main.js";

// stored values
let searchTextValue = "";
let searchTypeValue = "";
// let searchCountValue = 0; //nem global változót használok, hanem lokalt, így frissül minden alkalommal
let globalIndex = 0;

//esemény figyelése
function getCountValue() {
  return new Promise(resolve => {
    let resolved = false;

    EventBus.$once("result-count-updated", payload => {
      resolved = true;
      const { count } = payload;
      // searchCountValue = count ? count : 0;
      console.log("search:", count);
      resolve(count || 0);
    });
    //if no answer (count is not changed!)
    setTimeout(() => {
      if (!resolved) {
        resolve(0);
      }
    }, 2000);
  });
}

async function createDataObject() {
  const count = await getCountValue();
  return {
    event: "search",
    searchTerm: searchTextValue,
    searchMode: searchTypeValue,
    resultsNumber: count
  };
}

function sendDataLayerPush(dataToSend) {
  // console.log("--->>>", dataToSend);
  window.dataLayer.push(dataToSend);
}

async function startDataLayerPush(localIndex) {
  let dataObj = await createDataObject();
  if (dataObj && localIndex === globalIndex) {
    sendDataLayerPush(dataObj);
  }
}

//exporting methods
export default {
  searchTextChanged: async function(newTextValue, searchType) {
    if (newTextValue.length >= 3) {
      globalIndex++;
      let localIndex = globalIndex;
      // console.log("start", globalIndex, localIndex);
      //set global variables
      searchTextValue = newTextValue;
      searchTypeValue = searchType;
      startDataLayerPush(localIndex);
    }
    return;
  }
};

/* template:
dataLayer.push({
'event': 'search',
'searchTerm': {keresési kifejezés},
'searchMode': {oldalban/dokumentumban keresés},
'resultsNumber': {találatok száma} //ha nincs találat akkor 0
}
*/
